import { axios } from "../lib/axios";

export const getTermsOfPayment = async function (termsOfPaymentId) {
  try {
    const response = await axios.get("settings/gettermsofpayment", {
      params: { termsOfPaymentId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getAllTermsOfPayment = async function () {
  try {
    const response = await axios.get("settings/getalltermsofpayment");
    console.log(response);
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getAllTermsOfPaymentByType = async function (type) {
  try {
    const response = await axios.get("settings/getalltermsofpaymentbytype", {
      params: { type: type },
    });
    console.log(response);
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const addTermsOfPayment = async function (model) {
  try {
    const response = await axios.post("settings/addtermsofpayment", model, {
      header: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateTermsOfPayment = async function (model) {
  try {
    const response = await axios.post("settings/updatetermsofpayment", model, {
      header: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const deleteTermsOfPayment = async function (model) {
  try {
    const response = await axios.delete("settings/deletetermsofpayment", {
      data: model,
      header: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateCaseTermsOfPayment = async function (
  caseId,
  termsOfPaymentId,
  type
) {
  try {
    const response = await axios.put(
      "case/updatecasetermsofpayment",
      { caseId, termsOfPaymentId, type },
      {
        header: { "Content-Type": "application/json" },
      }
    );
    return response;
  } catch (error) {
    throw error.response;
  }
};
